import React from 'react';
import PropTypes from 'prop-types';

class Audio extends React.PureComponent {
    render() {
        return (
            <audio className="audio" preload="auto" data-audio-key={this.props.audioKey}>
                {this.props.mp3Src && <source src={this.props.mp3Src} type="audio/mpeg" />}
                {this.props.aifSrc && <source src={this.props.aifSrc} type="audio/aif" />}
                Your browser does not support the audio element.
            </audio>
        );
    }
}

Audio.propTypes = {
    // Data attribute that `AllAudio` component uses to find the HTMLElement when we want to play some audio
    audioKey: PropTypes.string.isRequired,

    // One of mp3Src or aifSrc should be set
    mp3Src: PropTypes.string,
    aifSrc: PropTypes.string,
};

export default Audio;
